const envSettings = window._env_;

export class Config {
    static backendUrl = envSettings.REACT_APP_BACKEND_URL;
    static audience = envSettings.REACT_APP_AUTH0_API_AUDIENCE;
    static redirectUri = envSettings.REACT_APP_AUTH0_CALLBACK_URL;
    static clientId = envSettings.REACT_APP_AUTH0_CLIENT_ID;
    static domain = envSettings.REACT_APP_AUTH0_DOMAIN;
}